// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__31E11","content":"styles_content__2WWyj","row":"styles_row__KXg4z","footer":"styles_footer__2VBMN","phraseLength":"styles_phraseLength__2zePm"};